import { format } from 'date-fns';
import { RecordLink } from 'components/record-chip/RecordLink';
import { useEffectiveDateFormat } from 'hooks/useEffectiveDateFormat';
import { MatterExperienceRecordDto } from 'types/experience-records.ts';
import { logError } from 'utils/monitoring';

interface Props {
    record: MatterExperienceRecordDto;
}

export function OpenedDateCell(props: Props) {
    const record: MatterExperienceRecordDto = props.record;
    const effectiveFormat = useEffectiveDateFormat();
    const matter = record.matter;
    if (!matter.isReadable) return null;
    let formattedDate = '-';
    try {
        const openedDate = matter.openedDate;
        const date = new Date(openedDate);
        formattedDate = format(date, effectiveFormat);
    } catch (e) {
        logError(e, {
            section: 'experience-records',
            operation: 'date-formatting',
            matter: {
                id: matter.id,
                fullName: matter.fullName,
                openedDate: matter.openedDate,
            },
        });
    }
    return (
        <div className="flex flex-col">
            {formattedDate}
            {matter.handledByOffice ? (
                <RecordLink
                    className="entity-link hover:text-link w-fit no-underline hover:underline"
                    to={`/office/${matter.handledByOffice.id}`}
                    label={matter.handledByOffice.name}
                />
            ) : null}
        </div>
    );
}
